import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    approveReleaseProposals,
    rejectReleaseProposals,
    ReleaseDecisionResult,
} from 'services/api/NumberRegistrationAPI';
import { queryKeys } from '../queryKeys';

export type ReleaseDecisionAction = 'approve' | 'reject';

export interface DecideReleaseProposalsParams {
    tenantId: string;
    phoneNumbers: string[];
    action: ReleaseDecisionAction;
}

export const useDecideReleaseProposals = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation<ReleaseDecisionResult, unknown, DecideReleaseProposalsParams>({
        mutationFn: ({ tenantId, phoneNumbers, action }: DecideReleaseProposalsParams) => {
            const decider = action === 'approve' ? approveReleaseProposals : rejectReleaseProposals;
            return decider(tenantId, phoneNumbers);
        },
        onSuccess: (_result, { tenantId }) => {
            // Either decision takes the numbers out of the proposal list.
            queryClient.invalidateQueries({ queryKey: queryKeys.releaseProposals(tenantId) });
        },
    });

    return { decideReleaseProposals: mutateAsync, isDecidingReleaseProposals: isPending };
};
